// extracted by mini-css-extract-plugin
export default {"column":"Layout_column__9Oxa2","breadcrumb":"Layout_breadcrumb__8pQ4V","title":"Layout_title__zVdYC","subtitle":"Layout_subtitle__sygd9"};